import { from, of } from 'rxjs'
import { catchError, exhaustMap, filter, map } from 'rxjs/operators'
import { isActionOf } from 'typesafe-actions'
import { toast } from 'react-toastify'
import { getBalancesRequest, getBalancesSuccess, getBalancesFailure, wsConnected } from '../actions'
import { RootEpic } from '../types'

export const getBalancesEpic: RootEpic = (action$, state$, { getBalances }) => {
  return action$.pipe(
    filter(isActionOf([getBalancesRequest, wsConnected])),
    exhaustMap(({ payload }) =>
      from(getBalances({ token: payload?.token || state$.value.app.authToken || '' })).pipe(
        map((response) => getBalancesSuccess(response)),
        catchError((message) => {
          toast.error('Failed to fetch user balances.')
          return of(getBalancesFailure(message))
        }),
      ),
    ),
  )
}

export default [getBalancesEpic]
